'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var React = require('react');
var bemReactClassname = require('bem-react-classname');
var link = require('@alfalab/core-components/link');
var typography = require('@alfalab/core-components/typography');
var cn = require('../../cn.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

/**
 * Компонент блока телефонов для связи с банком.
 */
var BankContacts = /** @class */ (function (_super) {
    tslib.__extends(BankContacts, _super);
    function BankContacts() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cn = bemReactClassname.createCn('bank-contacts-core');
        /**
         * Оставляем только цифры в телефоне.
         */
        _this.normalizePhone = function (phone) { return phone && phone.replace(/[^+\d]/g, ''); };
        return _this;
    }
    BankContacts.prototype.render = function () {
        var _this = this;
        var _a = this.props, id = _a.id, title = _a.title, items = _a.items, theme = _a.theme;
        return (React__default.default.createElement("div", { className: this.cn(), id: id, "data-test-id": this.props['data-test-id'] },
            title && (React__default.default.createElement("div", { className: this.cn('title') },
                React__default.default.createElement(typography.Typography.Text, { view: "primary-medium", className: this.cn('text'), color: "secondary" }, title))),
            React__default.default.createElement("div", { className: this.cn('wrapper') }, items && items.map(function (_a) {
                var phone = _a.phone, hint = _a.hint;
                return (React__default.default.createElement("div", { key: phone, className: _this.cn('item') },
                    React__default.default.createElement(typography.Typography.Title, { view: "xsmall", font: "system", tag: "h3", className: _this.cn('text') },
                        React__default.default.createElement(link.Link, { href: "tel:".concat(_this.normalizePhone(phone)), colors: cn.getCoreTheme(theme) },
                            React__default.default.createElement("span", { className: _this.cn('link') }, phone))),
                    hint && (React__default.default.createElement(typography.Typography.Text, { view: "primary-small", color: "secondary" }, hint))));
            }))));
    };
    BankContacts.defaultProps = {
        title: '',
        items: [
            { phone: '+7 495 755-58-58', hint: 'в Москве и за границей' },
            { phone: '8 800 100-77-33', hint: 'в любом городе России' },
        ],
    };
    return BankContacts;
}(React__default.default.Component));
/**
 * @visibleName BankContacts
 */
var BankContacts$1 = cn.withTheme(BankContacts);

exports.BankContacts = BankContacts;
exports.default = BankContacts$1;
